// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let EditableQuestionView
export default EditableQuestionView = (function () {
  EditableQuestionView = class EditableQuestionView extends (
    require("lib/static-shim").default(
      require("lib/utils/stately-view").default
    )
  ) {
    static initClass() {
      this.prototype.tagName = "li"

      this.prototype.states = {
        view: require("./question").default,
        delete: require("./delete-question-editor").default,
        new: require("./new-question-editor").default,
        edit: "getEditView"
      }
    }

    initialize() {
      super.initialize()
      return this.state.set("state", (this.model.isNew() && "new") || "view")
    }

    render() {
      if (this.triggerMethod != null) {
        this.triggerMethod("before:render")
      }

      this.$el
        .attr("class", "")
        .addClass("question")
        .attr("data-id", this.model.id)

      const qtype = this.model.getQuestionType()
      if (qtype) {
        const qtypeClass = qtype.name.replace(" ", "-").toLowerCase()
        this.$el.addClass(qtypeClass)
      }

      if (this.triggerMethod != null) {
        this.triggerMethod("render")
      }

      return super.render()
    }

    getEditView() {
      const type = this.model.get("assessment_question_type")
      switch (type) {
        case "1": //'multiple-choice'
          return require("./multiple-choice-question-editor").default
        case "2": //'paragraph'
          return require("./paragraph-question-editor").default
      }
    }
  }
  EditableQuestionView.initClass()
  return EditableQuestionView
})()
